import {CircularProgress} from '@material-ui/core'
import React from 'react'

const Loader = ({padding}: {padding: string})=><>
	<div style={{width: '100%', display: 'flex'}}>
		<div style={{margin: 'auto', paddingTop: padding, paddingBottom: padding}}>
			<CircularProgress />
		</div>
	</div>
</>
export default Loader